import { useLocation } from "react-router-dom";
import IMAGES from "../../constant/IMAGES";
import useResponsive from "../../hooks/useResponsive";
import { useEffect, useRef, useState } from "react";
import { detectAndHandleRedirect } from "../Home/Section1";
const items = [
  {
    label: "TRANG CHỦ",
    href: "#",
  },
  {
    label: "VỀ CHÚNG TÔI",
    href: "#ve-chung-toi",
  },
  {
    label: "TÍNH NĂNG NỔI BẬT",
    href: "#tinh-nang-noi-bat",
  },
  {
    label: "TÍNH NĂNG ĐỘC QUYỀN",
    href: "#tinh-nang-doc-quyen",
  },
  {
    label: "LIÊN HỆ",
    href: "#lien-he",
  },
  {
    label: "HỎI ĐÁP",
    href: "#hoi-dap",
  },
];
function Nav() {
  const { isBigScreen, isTabletOrLaptop } = useResponsive();
  const { pathname } = useLocation();
  const [activeSection, setActiveSection] = useState("");

  const isActive = (href: string) => {
    if (
      pathname === "/" &&
      (activeSection === "" || activeSection === "#") &&
      href === "#"
    ) {
      return true;
    }
    return href === activeSection;
  };

  const glowingEffect = {
    width: isBigScreen ? "70px" : "90px",
    height: "auto",
    animation: "glow 3s infinite ease-out",
    borderRadius: "50%",
  };

  const keyframesStyle = `
    @keyframes glow {
      0% {
        box-shadow: 0 0 0 0 rgba(180, 154, 64, 0.4), 0 0 0 10px rgba(180, 154, 64, 0.3), 0 0 0 20px rgba(180, 154, 64, 0.2);
      }
      50% {
        box-shadow: 0 0 10px 5px rgba(180, 154, 64, 0.6), 0 0 20px 15px rgba(180, 154, 64, 0.5), 0 0 30px 25px rgba(180, 154, 64, 0.4);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(180, 154, 64, 0.4), 0 0 0 10px rgba(180, 154, 64, 0.3), 0 0 0 20px rgba(180, 154, 64, 0.2);
      }
    }
  `;

  const [open, setOpen] = useState(false);
  const [translateX, setTranslateX] = useState(-400);
  const touchStartX = useRef(0);
  const touchCurrentX = useRef(0);
  const isSwiping = useRef(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showNav, setShowNav] = useState(true);

  useEffect(() => {
    setTranslateX(open ? 0 : -400);
  }, [open]);

  useEffect(() => {
    const sections = items.map((item) => item.href.replace("#", ""));

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (const section of sections) {
        if (section === "") continue;

        const element = document.getElementById(section);
        if (element) {
          const { top, bottom } = element.getBoundingClientRect();
          const elementTop = top + window.scrollY;
          const elementBottom = bottom + window.scrollY;

          if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
            setActiveSection(`#${section}`);
            return;
          }
        }
      }

      if (window.scrollY < window.innerHeight / 2) {
        setActiveSection("#");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartX.current = e.touches[0].clientX;
    isSwiping.current = true;
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!isSwiping.current) return;

    touchCurrentX.current = e.touches[0].clientX;
    const movement = touchCurrentX.current - touchStartX.current;
    let newTranslateX = open ? movement : -400 + movement;

    if (newTranslateX <= 0 && newTranslateX >= -280) {
      setTranslateX(newTranslateX);
    }
  };

  const handleTouchEnd = () => {
    isSwiping.current = false;

    if (translateX < -100) {
      setOpen(false);
    } else {
      setOpen(true);
      setTranslateX(0);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowNav(false); // Cuộn xuống -> Ẩn navbar
      } else {
        setShowNav(true); // Cuộn lên -> Hiện navbar
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden"); // Chặn cuộn
    } else {
      document.body.classList.remove("overflow-hidden"); // Bỏ chặn
    }
    return () => {
      document.body.classList.remove("overflow-hidden"); // Cleanup khi unmount
    };
  }, [open]);

  return (
    <div
      className={`fixed top-0 left-0 w-full transition-transform duration-300 z-50 ${
        showNav && !isTabletOrLaptop ? "translate-y-0" : "xl:-translate-y-full"
      }`}
    >
      <div
        className={`w-full h-[120px] 2xl:h-[150px] xl:flex hidden gap-[60px] items-center justify-center duration-300 transition-all ${
          isScrolled ? "bg-[#2D2000]" : ""
        }`}
      >
        <div className="flex justify-evenly w-full items-center gap-2 border-y-2 py-3 2xl:py-[20px] gradient-border ">
          {items.slice(0, 3).map((item) => (
            <a
              href={item.href}
              key={item.label}
              className="flex gap-2 items-center"
            >
              <div className="relative bg-white w-4 aspect-square rounded-full">
                <div
                  className={`absolute inset-0 transition-all duration-1000 ease-out ${
                    isActive(item.href) ? "bg-gold" : "bg-[#D0D2D3]"
                  } m-[3px] rounded-full`}
                />
              </div>
              <p
                className={`2xl:text-xl text-lg transition-all duration-1000 ease-out ${
                  isActive(item.href)
                    ? "text-goldGradient font-bold"
                    : "text-white font-normal hover:text-goldGradient"
                }`}
              >
                {item.label}
              </p>
            </a>
          ))}
        </div>
        <a href="#" className="flex-shrink-0">
          <style>{keyframesStyle}</style>
          <img src={IMAGES.logo} alt="" style={glowingEffect} />
        </a>
        <div className="flex justify-evenly w-full  border-y-2 py-3 2xl:py-[20px] gradient-border items-center gap-2">
          {items.slice(3, 8).map((item) => (
            <a
              href={item.href}
              key={item.label}
              className="flex gap-2 items-center"
            >
              <div className="relative bg-white w-4 aspect-square rounded-full">
                <div
                  className={`absolute inset-0 transition-all duration-1000 ease-out ${
                    isActive(item.href) ? "bg-gold" : "bg-[#D0D2D3]"
                  } m-[3px] rounded-full`}
                />
              </div>
              <p
                className={`2xl:text-xl text-lg transition-all duration-1000 ease-out ${
                  isActive(item.href)
                    ? "text-goldGradient font-bold"
                    : "text-white font-normal hover:text-goldGradient"
                }`}
              >
                {item.label}
              </p>
            </a>
          ))}
        </div>
      </div>
      <div
        className={`flex justify-between items-center xl:hidden p-4 sm:p-8 gap-16 xl:px-0 w-full relative z-50 ${
          isScrolled ? "bg-[#2D2000]" : "bg"
        }`}
      >
        <a href="#">
          <style>{keyframesStyle}</style>
          <img
            src={IMAGES.logo}
            alt="logo"
            className="!w-[40px]"
            style={glowingEffect}
          />
        </a>
        <img
          src={IMAGES.menu}
          alt="logo"
          className="w-8"
          onClick={() => setOpen(true)}
        />
      </div>

      {/* Menu nav MB*/}
      <>
        <div
          className={`fixed inset-0 z-50 transition-transform duration-300 ease-out xl:hidden flex
        ${open ? "pointer-events-auto" : "pointer-events-none"}`}
          style={{ transform: `translateX(${translateX}px)` }}
          onClick={() => setOpen(false)}
        >
          <div
            className="h-full overflow-y-auto z-[60] bg-black w-[310px] overflow-hidden relative rounded-e-3xl flex flex-col items-center gap-9 p-6 shadow-[1px_0px_10px_0px_#FFFFFF40]"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span className="absolute top-0 left-0 w-full h-full bg-overlay opacity-50 pointer-events-none" />
            <img src={IMAGES.logodoc} alt="logo" className="w-[60px]" />
            <div className="flex flex-col gap-5 w-full">
              {items.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <a
                    href={item.href}
                    key={item.label}
                    className="flex gap-4 items-center"
                  >
                    <div className="relative bg-white w-4 aspect-square rounded-full">
                      <div
                        className={`absolute inset-0 transition-all duration-1000 ease-out ${
                          isActive(item.href) ? "bg-gold" : "bg-[#D0D2D3]"
                        } m-[3px] rounded-full`}
                      />
                    </div>
                    <p
                      className={`text-base !capitalize transition-all duration-1000 ease-out ${
                        isActive(item.href)
                          ? "text-goldGradient font-bold"
                          : "text-white font-normal hover:text-goldGradient"
                      }`}
                    >
                      {item.label}
                    </p>
                  </a>
                </div>
              ))}
            </div>

            <span className="gradient-border !border-[1px] w-full" />

            <div className="flex flex-col items-center gap-[20px] relative z-10">
              <p className="text-goldGradient text-base md:text-lg text-justify">
                Quét QR code để trải nghiệm các tính năng từ Xhero App
              </p>
              <img
                src={IMAGES.qrApp}
                alt="qr"
                className="w-1/2"
                onClick={() => detectAndHandleRedirect()}
              />
            </div>

            <img
              src={IMAGES.menubg}
              alt=""
              className="absolute bottom-0 pointer-events-none"
            />
          </div>
        </div>
      </>
    </div>
  );
}

export default Nav;
